import { Box, Group, Stack, Text, Tooltip } from '@mantine/core';
import React from 'react';

import { DeviceType } from '@portals/api/organizations';
import { ReactComponent as Hierarchy2 } from '@portals/icons/linear/hierarchy-2.svg';
import { ReactComponent as Hierarchy } from '@portals/icons/linear/hierarchy.svg';

interface DeviceRelationsIndicatorProps {
  device: DeviceType;
}

export function DeviceRelationsIndicator({
  device,
}: DeviceRelationsIndicatorProps) {
  return (
    <>
      {device.parent_device ? (
        <Tooltip
          withinPortal
          withArrow
          label={
            <Stack w={120} px="md" py="xs" spacing={4}>
              <Text size="xs">Parent Device:</Text>

              <Text size="xs">{device?.parent_device?.name || 'Unknown'}</Text>
            </Stack>
          }
        >
          <Group align="center" spacing={4}>
            <Box sx={(theme) => ({ color: theme.colors.blue_gray[4] })}>
              <Hierarchy2 width={18} height={18} />
            </Box>
          </Group>
        </Tooltip>
      ) : null}

      {device.child_devices_count ? (
        <Tooltip withinPortal withArrow label="Num of Child Devices">
          <Group align="center" spacing={4}>
            <Box sx={(theme) => ({ color: theme.colors.blue_gray[4] })}>
              <Hierarchy width={18} height={18} />
            </Box>

            <Text size="xs">{device.child_devices_count}</Text>
          </Group>
        </Tooltip>
      ) : null}
    </>
  );
}
